import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import React, { useEffect } from 'react';
import 'primeflex/primeflex.css';
import { jwtDecode } from 'jwt-decode';
import { useLocation, useNavigate } from "react-router";


const GUNDILER = [8, 9, 41]
const WH = [7, 37, 44]
const ALL = [7, 8, 9, 37, 41, 44]

const LoginView = () => {

    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        localStorage.removeItem('loggedInUserName')

        /* global google */
        google.accounts.id.initialize({
            client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
            callback: (response) => {
                var authUserData = jwtDecode(response.credential)
                localStorage.removeItem('bearerToken')
                localStorage.setItem('googleIdToken', response.credential)
                localStorage.setItem('loggedInUserName', authUserData.name)

                localStorage.setItem('loggedInUserEmail', authUserData.email)
                localStorage.setItem('loggedInUserPicture', authUserData.picture)
                switch (authUserData.email) {
                    case 'sevtekin@gmail.com':
                        localStorage.setItem('dataAccess', WH)
                        localStorage.setItem('adminAccess', false)
                        break
                    case 'dukeofmakefield@gmail.com':
                        localStorage.setItem('dataAccess', GUNDILER)
                        localStorage.setItem('adminAccess', false)
                        break
                    case 'cisevtekin@gmail.com':
                        localStorage.setItem('dataAccess', GUNDILER)
                        localStorage.setItem('adminAccess', false)
                        break
                    case 'sevtekin@google.com':
                        localStorage.setItem('dataAccess', ALL)
                        localStorage.setItem('adminAccess', true)
                        break
                    default:
                        localStorage.setItem('dataAccess', [])
                        localStorage.setItem('adminAccess', false)
                        break
                }
                if (location.state?.from) {
                    navigate(location.state.from);
                } else {
                    navigate('/');
                }
            }
        });

        google.accounts.id.renderButton(
            document.getElementById("signInDiv"),
            { theme: "outlined" }
        );
    }, [navigate, location.state]);

    return (
        <div id="signInDiv" />
    )
};

export default LoginView;